export default class LocationHelper {

  static getLocation() {
    return navigator.language
  }

}

